"use client";

/**
 * Shared typography utility classes to keep section text consistent.
 */
export const sectionLabelClass =
  "text-sm font-semibold uppercase tracking-wide text-primary-700 dark:text-primary-200";

export const sectionHeadingClass =
  "text-3xl font-bold text-slate-900 dark:text-slate-100 sm:text-4xl";

export const sectionIntroClass = "max-w-3xl text-lg text-slate-600 dark:text-slate-300";

export const bodyTextClass = "text-base text-slate-600 dark:text-slate-300";

export const mutedBodyTextClass = "text-base text-slate-500 dark:text-slate-400";

export const cardHeadingClass = "text-xl font-semibold text-slate-900 dark:text-slate-100";

export const subLabelClass =
  "text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400";
